module.exports = __webpack_public_path__ + "img/康和达白.c03c024d.png";